import { ParametersModule } from '../app/available-modules-mapper';
import { UserDependent, UserPrincipal } from '../app/types';

export interface TwsUserParameters {
  hasAccessToUserRegistration: boolean;
}
class UserContext {
  static patientId: number;
  static holderPatientId: number;
  static twsUserAvailableModules: ParametersModule[];
  static twsUserParameters: TwsUserParameters = UserContext.getTwsUserDefaultParameters();
  static userDependents?: UserDependent[];
  static userPrincipal?: UserPrincipal;

  private static getTwsUserDefaultParameters(): TwsUserParameters {
    return {
      hasAccessToUserRegistration: true,
    }
  }
}

export default UserContext;